import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoginPayload } from "@src/interfaces/auth.interface";
import { profileApi } from "@entities/profile";
import {
    getUUID,
    removeAccessToken,
    removeRefreshToken,
    setAccessToken,
    setRefreshToken} from "@shared/lib/utils";
import { API } from "../authSlice";
import { hideRegistrationForm } from "../layoutSlice";
import { LoginResponse } from "../types";

export const registerUser = createAsyncThunk<LoginResponse, any, { rejectValue: { message: any } }>(
    "auth/register",
    async (payload: LoginPayload, thunkAPI) => {
        try {
            const response = await fetch(`${API}/v1/users/registration`, {
                method: "POST",
                headers: { "Content-Type": "application/json", "X-DEVICE-UUID": getUUID() },
                body: JSON.stringify(payload)
            });

            let data: LoginResponse = await response.json();

            if (response.status === 200) {
                const token = data?.data?.accessToken;
                const refreshToken = data?.data?.refreshToken;
                if (!token) {
                    throw new Error("No token come from server");
                }
                setAccessToken(token);
                setRefreshToken(refreshToken);
                thunkAPI.dispatch(hideRegistrationForm());
                const profileQuery = profileApi.endpoints.getProfile.initiate({
                    accessToken: token
                });

                const res = await thunkAPI.dispatch(profileQuery);

                localStorage.setItem("user", JSON.stringify(res.data));
                return {
                    ...data,
                    user: res.data
                };
            } else {
                removeAccessToken();
                removeRefreshToken();

                const message =
                    typeof data.data === "object" && !Array.isArray(data?.data)
                        ? data.data
                        : data?.message;
                return thunkAPI.rejectWithValue({
                    message: message || "Something went wrong"
                });
            }
        } catch (e: any) {
            return thunkAPI.rejectWithValue({
                message: e.response.data || "Something went wrong"
            });
        }
    }
);